exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quill-editor img{max-width:100%}.quill-editor .ql-container{background-color:#fff;font-size:16px}", ""]);

// exports
